'use strict';


import { Box3, Group } from 'three';
import { Tile } from './Tile';

export class TilesSide extends Group{
	constructor (side,level,config) {
		super();
		
		this.side = side;
		this.level = level;
		this.config = config;
		
		this.name = `${side}_${level}`;
		this.tiles = [];
		this.visibleTiles = [];
		this.bbox = new Box3();
		
		this.#setPosition();
		
		const count = Math.pow(4,this.level);
		console.log('Level: ' + this.level + ' Count: ' + count);
		
		const tiles = Math.sqrt(count);
		const tileSize = this.config.size / tiles;
		
		for (let y = 0; y < tiles; y++) {
			for (let x = 0; x < tiles; x++) {
				const tile = new Tile(tileSize,x,y,this.level,this.side,this.config);
				tile.parent = this;
				this.tiles.push(tile);
				this.add(tile.mesh);
			}
		}
		
		this.bbox.setFromObject(this);
	}
	
	isLoaded() {
		return this.tiles.every(tile => tile.loaded);
	}
	
	setTexture(key,texture) {
		this.tiles.forEach(tile => tile.setTexture(key,texture));
	}
	
	setPanoMatrix(mat4) {
		this.tiles.forEach(tile => tile.setPanoMatrix(mat4));
	}
	
	load(tl) {
		this.tiles.forEach(tile => tile.load(tl));
	}
	
	inView(frustum) {
		return frustum.intersectsBox(this.bbox);
	}
	
	isRemoved() {
		return !Boolean(this.parent);
	}
	
	dispose() {
		if (this.isRemoved())
			return;
		
		this.removeFromParent();
		this.tiles.forEach(tile => tile.dispose());
	}
	
	#setPosition() {
		switch (this.side) {
			case 'px':
				this.rotation.y = -Math.PI / 2;
				this.position.x = -this.config.size / 2;
				break;
			case 'nx':
				this.rotation.y = Math.PI / 2;
				this.position.x = this.config.size / 2;
				break;
			case 'py':
				this.rotation.x = -Math.PI / 2;
				this.position.y = this.config.size / 2;
				break;
			case 'ny':
				this.rotation.x = Math.PI / 2;
				this.position.y = -this.config.size / 2;
				break;
			case 'pz':
				this.position.z = this.config.size / 2;
				break;
			case 'nz':
				this.position.z = -this.config.size / 2;
				this.rotation.y = Math.PI;
				break;
		}
	}
	
}
